import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Formik } from "formik";
import * as yup from "yup";
import { ModalAllder } from "layouts/ModalAllder";
import { getAllMstPrefix } from "../../redux/handlers/master/getAllMstPrefix.handler";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import "./PartnerCreateModal.css";
var initialValues = {
    prefixId: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: ""
};
var schema = yup.object({
    prefixId: yup.string().required("กรุณาเลือกคำนำหน้าชื่อ"),
    firstName: yup.string().trim().required("กรุณากรอกชื่อ"),
    lastName: yup.string().trim().required("กรุณากรอกนามสกุล"),
    phone: yup.string().trim().required("กรุณากรอกเบอร์โทร").matches(/^\+?[0-9\s()-]{8,20}$/, "กรุณากรอกเบอร์โทรให้ถูกต้อง"),
    email: yup.string().trim().email("รูปแบบอีเมลไม่ถูกต้อง").required("กรุณากรอกอีเมล"),
    password: yup.string().required("กรุณากรอกรหัสผ่าน").min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"),
    confirmPassword: yup.string().required("กรุณายืนยันรหัสผ่าน").oneOf([
        yup.ref("password")
    ], "ยืนยันรหัสผ่านไม่ตรงกัน")
});
export default function PartnerCreateModal(param) {
    var modal = param.modal, setModal = param.setModal, onSave = param.onSave;
    var _prefixState_data;
    var dispatch = useAppDispatch();
    var prefixState = useAppSelector(function(state) {
        return state.getAllMstPrefixReducer;
    });
    var prefixes = Array.isArray((_prefixState_data = prefixState.data) === null || _prefixState_data === void 0 ? void 0 : _prefixState_data.data) ? prefixState.data.data : [];
    var prefixUnavailable = prefixState.isFetching || prefixState.isError || prefixes.length === 0;
    useEffect(function() {
        dispatch(getAllMstPrefix());
    }, [
        dispatch
    ]);
    var _useState = _sliced_to_array(useState({}), 2), visible = _useState[0], setVisible = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), notice = _useState1[0], setNotice = _useState1[1];
    var close = function() {
        return setModal(function(previous) {
            return _object_spread_props(_object_spread({}, previous), {
                open: false
            });
        });
    };
    return /*#__PURE__*/ _jsx(ModalAllder, {
        modal: modal,
        setModal: setModal,
        htitle: "สร้าง Partner",
        hbtn: true,
        children: /*#__PURE__*/ _jsx(Formik, {
            initialValues: initialValues,
            validationSchema: schema.shape({
                prefixId: yup.string().required("กรุณาเลือกคำนำหน้าชื่อ").oneOf(prefixes.map(function(item) {
                    return String(item.id);
                }), "กรุณาเลือกคำนำหน้าชื่อ")
            }),
            onSubmit: function() {
                var _ref = _async_to_generator(function(values, param) {
                    var setSubmitting, payload, result, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setSubmitting = param.setSubmitting;
                                setNotice(null);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                // Map these form fields to the API contract when it is available.
                                payload = {
                                    prefixId: Number(values.prefixId),
                                    firstName: values.firstName.trim(),
                                    lastName: values.lastName.trim(),
                                    phone: values.phone.trim(),
                                    email: values.email.trim(),
                                    password: values.password,
                                    confirmPassword: values.confirmPassword
                                };
                                return [
                                    4,
                                    onSave(payload)
                                ];
                            case 2:
                                result = _state.sent();
                                setNotice({
                                    variant: "info",
                                    message: result.message
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                e = _state.sent();
                                setNotice({
                                    variant: "danger",
                                    message: "ไม่สามารถเตรียมข้อมูลได้ กรุณาลองใหม่"
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                setSubmitting(false);
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(values, _) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(param) {
                var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, resetForm = param.resetForm, isSubmitting = param.isSubmitting;
                var input = function(name, label) {
                    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "text", placeholder = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                    var isPassword = type === "password";
                    var invalid = Boolean(touched[name] && errors[name]);
                    return /*#__PURE__*/ _jsxs(Form.Group, {
                        controlId: "partner-create-".concat(name),
                        className: "partner-create-field mb-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                children: [
                                    label,
                                    " ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(InputGroup, {
                                hasValidation: true,
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        name: name,
                                        value: values[name],
                                        required: true,
                                        type: isPassword && visible[name] ? "text" : type,
                                        placeholder: placeholder || "กรอก".concat(label),
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        isInvalid: invalid,
                                        disabled: isSubmitting,
                                        autoComplete: isPassword ? "new-password" : name === "phone" ? "tel" : name === "email" ? "email" : "off"
                                    }),
                                    isPassword && /*#__PURE__*/ _jsx(Button, {
                                        type: "button",
                                        variant: "outline-secondary",
                                        disabled: isSubmitting,
                                        "aria-label": "".concat(visible[name] ? "ซ่อน" : "แสดง").concat(label),
                                        onClick: function() {
                                            return setVisible(function(previous) {
                                                return _object_spread_props(_object_spread({}, previous), _define_property({}, name, !previous[name]));
                                            });
                                        },
                                        children: visible[name] ? /*#__PURE__*/ _jsx(VisibilityOff, {
                                            fontSize: "small"
                                        }) : /*#__PURE__*/ _jsx(Visibility, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control.Feedback, {
                                        type: "invalid",
                                        children: errors[name]
                                    })
                                ]
                            })
                        ]
                    });
                };
                return /*#__PURE__*/ _jsxs(Form, {
                    noValidate: true,
                    onSubmit: handleSubmit,
                    className: "partner-create-form pb-5",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "fs-18 mb-3",
                            children: "ข้อมูลส่วนตัว"
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    xl: 7,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        controlId: "partner-create-prefixId",
                                        className: "partner-create-field mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                children: [
                                                    "คำนำหน้าชื่อ ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Form.Select, {
                                                name: "prefixId",
                                                value: values.prefixId,
                                                required: true,
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                disabled: isSubmitting || prefixUnavailable,
                                                isInvalid: Boolean(touched.prefixId && errors.prefixId),
                                                children: [
                                                    /*#__PURE__*/ _jsx("option", {
                                                        value: "",
                                                        children: prefixState.isFetching ? "กำลังโหลดคำนำหน้าชื่อ..." : "เลือกคำนำหน้าชื่อ"
                                                    }),
                                                    prefixes.map(function(item) {
                                                        return /*#__PURE__*/ _jsx("option", {
                                                            value: item.id,
                                                            children: item.name
                                                        }, item.id);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control.Feedback, {
                                                type: "invalid",
                                                children: errors.prefixId
                                            }),
                                            !prefixState.isFetching && prefixUnavailable && /*#__PURE__*/ _jsxs("div", {
                                                className: "text-danger small mt-1",
                                                role: "alert",
                                                children: [
                                                    prefixState.isError ? "โหลดคำนำหน้าชื่อไม่สำเร็จ" : "ไม่พบข้อมูลคำนำหน้าชื่อ",
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        variant: "link",
                                                        size: "sm",
                                                        onClick: function() {
                                                            return dispatch(getAllMstPrefix());
                                                        },
                                                        children: "ลองใหม่"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    children: input("firstName", "ชื่อ")
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    children: input("lastName", "นามสกุล")
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    xl: 7,
                                    children: input("phone", "เบอร์โทร", "tel")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "fs-18 mt-3 mb-3",
                            children: "ข้อมูลการใช้งาน"
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    xl: 7,
                                    children: input("email", "อีเมล", "email")
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    children: input("password", "รหัสผ่าน", "password")
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    children: input("confirmPassword", "ยืนยันรหัสผ่าน", "password", "ยืนยันรหัสผ่าน")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-muted small mb-3",
                            children: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"
                        }),
                        notice && /*#__PURE__*/ _jsx(Alert, {
                            variant: notice.variant,
                            role: "status",
                            children: notice.message
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex justify-content-end gap-3 mt-4",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 py-2 px-3",
                                    disabled: isSubmitting,
                                    onClick: function() {
                                        resetForm();
                                        setVisible({});
                                        setNotice(null);
                                        close();
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn btn-dg py-2 px-4",
                                    disabled: isSubmitting || prefixUnavailable,
                                    children: isSubmitting ? "กำลังเตรียมข้อมูล..." : "บันทึก"
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
}
